import React from 'react';
import { Nav, NavItem, NavLink as ReactStrapNavLink, UncontrolledCollapse } from 'reactstrap';
import { StyleOne, StyleTwo } from '../components/RelatedSCard';
import faqs from '../data/faqs.json'
import financials from '../data/financials.json'
import { News, Gallery, Videos } from '../components/Resources';

export default class Resources extends React.Component {

  componentDidMount() {
    this.setState({ faqs, financials })
  }

  state = {
    link: this.props.match.params.tabview,//"faqs",
    faqs: {
      faqs: []
    },
    financials: {
      financials: []
    },
  }

  setActive = (value) => {
    this.setState({ link: value })
  }
  render() {
    const { link, faqs, financials } = this.state;
    let headText = "All you need to know in one place";
    if (link === "faqs"){
      headText = "All you need to know in one place";
    }else if (link === "financials"){
      headText = "We provide transparent financial records to all stakeholders";
    }else if (link === "media"){
      headText = "Media, Press Releases, Publications, and much more!";
    }
    return (
      <div className="resources">
        <div className="hero">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h1 className="white-text">{headText}</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-container">
          {link === "faqs" && <Nav tabs justified>
            <NavItem active onClick={() => { this.setActive("faqs") }}>
              <ReactStrapNavLink href="#">FAQs</ReactStrapNavLink>
            </NavItem>
            <NavItem onClick={() => { this.setActive("financials") }} >
              <ReactStrapNavLink href="#">Financials</ReactStrapNavLink>
            </NavItem>
            <NavItem onClick={() => { this.setActive("media") }}>
              <ReactStrapNavLink href="#">Media Centre</ReactStrapNavLink>
            </NavItem>
          </Nav>}
          {link === "financials" && <Nav tabs justified>
            <NavItem onClick={() => { this.setActive("faqs") }}>
              <ReactStrapNavLink href="#">FAQs</ReactStrapNavLink>
            </NavItem>
            <NavItem active onClick={() => { this.setActive("financials") }} >
              <ReactStrapNavLink href="#">Financials</ReactStrapNavLink>
            </NavItem>
            <NavItem onClick={() => { this.setActive("media") }}>
              <ReactStrapNavLink href="#">Media Centre</ReactStrapNavLink>
            </NavItem>
          </Nav>}
          {link === "media" && <Nav tabs justified>
            <NavItem onClick={() => { this.setActive("faqs") }}>
              <ReactStrapNavLink href="#">FAQs</ReactStrapNavLink>
            </NavItem>
            <NavItem onClick={() => { this.setActive("financials") }} >
              <ReactStrapNavLink href="#">Financials</ReactStrapNavLink>
            </NavItem>
            <NavItem active onClick={() => { this.setActive("media") }}>
              <ReactStrapNavLink href="#">Media Centre</ReactStrapNavLink>
            </NavItem>
          </Nav>}
        </div>

        {link === "faqs" && <div className="container-fluid tab-content">
          {faqs.faqs.map(question => <div key={question.id} className="tab-item">
            <div className="row toggle-heading" id={`toggler${question.id}`}>
              <div className="col-10">
                <span>{question.question}</span>
              </div>
              <div className="col-2 text-right">
                <i className="fa fa-chevron-down light-blue-text"></i>
              </div>
            </div>
            <UncontrolledCollapse toggler={`toggler${question.id}`}>
              <p>{question.answer}</p>
            </UncontrolledCollapse>
          </div>)}
        </div>}

        {link === "financials" && <div className="container-fluid tab-content researchaccordion">
          <div className="row">
            {financials.financials.map(financial => <div key={financial.id} className="col-4 col-sm-3  col-xl-2 res-doc">
              <div className="card financials-card gray-bg">
                <p className="bold white-text to-bottom">{financial.desc}</p>
              </div>
            </div>)}
          </div>
        </div>}

        {link === "media" && <div className="container-fluid tab-content">
          <News />
          <Gallery />
          <Videos />
        </div>}
        {/* <div className="section-alt">
          <div className="container-fluid">
            <div className="row">
              <StyleOne tag='resources' serviceDesc='Compliance 2019' bgcolor='dark-blue-bg' buttonText='Download' />
              <StyleTwo tag='resources' serviceDesc='Whistleblowing Policy 2019' bgcolor='dark-blue-bg' buttonText='Find out more' />
              <StyleOne tag='resources' serviceDesc='Download Forms' bgcolor='light-blue-bg' buttonText='Learn more' />
              <StyleTwo tag='resources' serviceDesc='Whistleblowing Policy 2019' bgcolor='dark-blue-bg' buttonText='Find out more' />
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}